export const priceRange = (from: string, to: string, currency: string) => {
  return `${from || 0}${to ? '-' : ' ' + currency + ' +'}${to ? to + ' ' + currency : ''}`
}
